import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { useGetReportQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import BookerDetailsReportList from './BookerDetailsReportList';

export default function BookerDetailsComponentPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const { data: getReport } = useGetReportQuery(`/reports/bookers`);

    return (
        <Grid sx={{ paddingBottom: 2, marginTop: isMobile ? '30px' : '0px' }}>
            <BookerDetailsReportList data={getReport} />
        </Grid>
    );
}
